export default __webpack_public_path__ + "static/social-trends-376cd9ef96c46081e882956d062e0db6.png";